import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";

const USER_DETAIL_ROUTE_REGEX = /users\/detail\/([^/?#]+)/;
const SUB_USER_TARGETS = [
  /\/client\/monitoring_sheet(?:[/?#]|$)/,
  /\/v1\/fast-notes(?:[/?#]|$)/,
];

function isSubUserTargetRequest(url: string): boolean {
  return SUB_USER_TARGETS.some(pattern => pattern.test(url));
}

export const userIdInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const match = router.url.match(USER_DETAIL_ROUTE_REGEX);

  if (match && match[1] && isSubUserTargetRequest(req.url)) {
    const userId = match[1];

    const modifiedReq = req.clone({
      headers: req.headers.set("x-sub-userid", userId),
    });

    return next(modifiedReq);
  }

  return next(req);
};
